// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderApprovalDetailsActionButtonsStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsActionButtons";
import Printer from "@insite/mobius/Icons/Printer";
import Save from "@insite/mobius/Icons/Save";
import Trash2 from "@insite/mobius/Icons/Trash2";
import ArrowRight from "@steiner/XDL/Icons/ArrowRight";
import Edit from "@steiner/XDL/Icons/Edit";
import { css } from "styled-components";

orderApprovalDetailsActionButtonsStyles.printButton = {
    variant: "link" as any,
    icon: {
        src: Printer,
        position: "left",
    },
    sizeVariant: "small",
};

orderApprovalDetailsActionButtonsStyles.continueShoppingButton = {
    variant: "link" as any,
    icon: {
        src: ArrowRight,
        position: "left",
    },
    sizeVariant: "small",
};

orderApprovalDetailsActionButtonsStyles.deleteButton = {
    variant: "link" as any,
    icon: {
        src: Trash2,
        position: "left",
    },
    sizeVariant: "small",
};

orderApprovalDetailsActionButtonsStyles.approveButton = {
    css: css`
        width: 100%;
    `,
};

orderApprovalDetailsActionButtonsStyles.requestRevisionButton = {
    variant: "link" as any,
    sizeVariant: "small",
};

orderApprovalDetailsActionButtonsStyles.editButton = {
    variant: "link" as any,
    sizeVariant: "small",
    icon: {
        src: Edit,
        position: "left",
    },
};
